import { getQueryStringParameter } from '../helpers';

$(() => {
  const $modal = $('.modal#chooseProfile');
  const showModalOnLoad = getQueryStringParameter('show_new_profile_modal');

  if ($modal.length > 0 && showModalOnLoad === 'true') {
    $modal.modal('show');
  }
});
